<template>
  <GmapMap
    :center="center"
    :zoom="10"
    ref="map"
    :options="{
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      disableDefaultUi: false
    }"
    map-type-id="roadmap"
    style="width: 100%; height: 500px"
  >
    <GmapMarker
      :key="'marcador-establecimiento-mapa' + index"
      v-for="(m, index) in markers"
      :position="m.position"
      :clickable="true"
      :draggable="false"
      @click="centerMap(m, index)"
    >
      <GmapInfoWindow
        :opened="ventanasInfo === index"
        :options="{
          maxWidth: 300
        }"
        :key="'encabzado-establecimiento-mapa' + index"
        @closeClick="closeInfoWindow(index)"
      >
        <div class="w-90 mx-auto">
          <b-row class="mx-auto">
            <!-- mini ficha mapa -->
            <router-link :to="'/establecimiento/' + m.rbd" class="pb-2">
              <span
                class="mx-auto h6 text-center align-self-center font-weight-bold gilmer text-morado-claro pt-2 mb-1"
                >{{ m.nombre }}</span
              >
            </router-link>
            <!-- <img class="img-fluid d-none d-lg-block px-1" src="https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/foto-colegio-3.jpg" alt=""> -->
            <b-col cols="12" class="px-0 bg-white px-1 pb-1">
              <b-row
                class="w-100 mx-0 border border-bottom-0 py-1 justify-content-center"
              >
                <Simbologia
                  :rbd="Number(m.rbd)"
                  class="justify-content-center"
                  posicionTooltip="bottom"
                  :mostrarCopago="true"
                  :esGratuito="m.gratuituidad"
                  :genero="m.regimen"
                  :subvencionPreferencial="m.subvencionPreferencial"
                  :integracionEscolar="m.integracionEscolar"
                />
              </b-row>
              <div class="border">
                <b-row class="py-2 px-3">
                  <b-col cols="2" class="my-1 px-2 text-right">
                    <FontAwesomeIcon
                      icon="map-marker-alt"
                      class="text-morado-claro my-auto"
                    ></FontAwesomeIcon>
                  </b-col>
                  <b-col
                    cols="10"
                    class="px-1 pt-1 text-left text-morado-claro"
                    >{{ m.direccion }}</b-col
                  >
                  <b-col cols="2" class="my-1 px-2 text-right">
                    <FontAwesomeIcon
                      icon="university"
                      class="text-morado-claro my-auto"
                    ></FontAwesomeIcon>
                  </b-col>
                  <b-col
                    cols="10"
                    class="px-1 pt-1 text-left text-morado-claro"
                    >{{ m.dependencia }}</b-col
                  >
                  <b-col cols="2" class="my-1 px-2 text-right">
                    <FontAwesomeIcon
                      icon="chalkboard-teacher"
                      class="text-morado-claro my-auto"
                    ></FontAwesomeIcon>
                  </b-col>
                  <b-col cols="10" class="px-1 pt-1 text-left text-morado-claro"
                    >{{ m.nivelMinimo }} - {{ m.nivelMaximo }}</b-col
                  >
                  <b-col cols="2" class="my-1 px-2 text-right">
                    <FontAwesomeIcon
                      icon="user-friends"
                      class="text-morado-claro my-auto"
                    ></FontAwesomeIcon>
                  </b-col>
                  <b-col cols="10" class="px-1 pt-1 text-left text-morado-claro"
                    >{{ m.matriculados }} matriculados</b-col
                  >
                  <b-col cols="2" class="my-1 px-2 text-right">
                    <FontAwesomeIcon
                      icon="id-card-alt"
                      class="text-morado-claro my-auto"
                    ></FontAwesomeIcon>
                  </b-col>
                  <b-col cols="10" class="px-1 pt-1 text-left text-morado-claro"
                    >{{ m.promedioAlumnosPorCurso }} alumnos por curso</b-col
                  >
                  <b-col cols="12">
                    <router-link
                      :to="'/establecimiento/' + m.rbd"
                      :target="targetDetalle"
                      class="btn btn-sm w-100 text-center mt-3 btn-yellow"
                      >{{ textoDetalle }}</router-link
                    >
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </div>
      </GmapInfoWindow>
    </GmapMarker>
  </GmapMap>
</template>

<script>
import Simbologia from "@/components/generales/Simbologia";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faMapMarkerAlt,
  faChalkboardTeacher,
  faUniversity,
  faUserFriends,
  faIdCardAlt
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(
  faMapMarkerAlt,
  faChalkboardTeacher,
  faUniversity,
  faUserFriends,
  faIdCardAlt
);
export default {
  components: {
    FontAwesomeIcon,
    Simbologia
  },
  props: {
    establecimientos: {
      type: Array,
      required: true
    },
    vista: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      center: {
        lat: -33.443018,
        lng: -70.65387
      },
      ventanasInfo: -1
    };
  },
  watch: {
    vista() {
      if (this.vista === "mapa") {
        this.ajustarMapa();
      }
    },
    establecimientos() {
      this.ajustarMapa();
    }
  },
  computed: {
    markers() {
      let arreglo = [];
      this.establecimientos.forEach(est => {
        est.sedes.forEach(s => {
          arreglo.push({
            position: {
              lng: s.direccion.coordenadas.coordinates[0],
              lat: s.direccion.coordenadas.coordinates[1]
            },
            dependencia: est.dependencia,
            regimen: est.informacionInstitucional.regimen,
            subvencionPreferencial: this.esSep(est),
            integracionEscolar: this.esPie(est),
            distancia: 0,
            rbd: est.rbd,
            nombre: est.nombre,
            direccion: s.direccion.calle,
            nivelMinimo: est.nivelMinimo,
            nivelMaximo: est.nivelMaximo,
            gratuituidad: this.esGratuito(est),
            matriculados: est.informacionInstitucional.alumnosMatriculados,
            promedioAlumnosPorCurso:
              est.informacionInstitucional.promedioAlumnosPorCurso
          });
        });
      });
      return arreglo;
    },
    targetDetalle() {
      if (MODO_SHINNY_VACANTES) {
        return "_blank";
      } else {
        return "_self";
      }
    },
    textoDetalle() {
      if (MODO_SHINNY_VACANTES) {
        return "VER VACANTES";
      } else {
        return "VER DETALLE";
      }
    }
  },
  methods: {
    centerMap(marker, index) {
      this.ventanasInfo = index;
    },
    closeInfoWindow(index) {
      this.ventanasInfo = -1;
    },
    esGratuito: function(establecimiento) {
      if (establecimiento.etiquetas !== undefined) {
        return establecimiento.etiquetas.includes("GRATUITO");
      } else {
        return false;
      }
    },
    esSep(establecimiento) {
      if (establecimiento.etiquetas !== undefined) {
        return establecimiento.etiquetas.includes("SEP");
      } else {
        return false;
      }
    },
    esPie(establecimiento) {
      if (establecimiento.etiquetas !== undefined) {
        return establecimiento.etiquetas.includes("PIE");
      } else {
        return false;
      }
    },
    ajustarMapa() {
      this.ventanasInfo = -1;
      // reajuste del mapa dsegun los marcadores
      if (this.establecimientos.length > 0) {
        const bounds = new google.maps.LatLngBounds();
        this.establecimientos.forEach(est => {
          est.sedes.forEach(s => {
            //entrega posicion para recalculo de centro
            this.ventanasInfo = -1;
            bounds.extend({
              lng: s.direccion.coordenadas.coordinates[0],
              lat: s.direccion.coordenadas.coordinates[1]
            });
          });
        });
        this.$refs.map.panToBounds(bounds);
        this.$refs.map.fitBounds(bounds);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/busqueda/establecimientos/Mapa.vue